import {
    ComponentFactory, ComponentFactoryResolver, ComponentRef, Directive, NgZone, OnDestroy,
    ViewContainerRef,
} from '@angular/core';
import { LoaderComponent } from 'app/utils/loader/loader.component';


@Directive({
    selector: '[i360Loader],[i360-request]:not([i360-no-loader])',
    exportAs: 'i360Loader',
})
export class LoaderDirective implements OnDestroy {
    private factory: ComponentFactory<LoaderComponent>;
    private ref: ComponentRef<LoaderComponent> | null;
    private actions: string[] = [];
    private previousState;
    constructor(private container: ViewContainerRef,
                private zone: NgZone,
                resolver: ComponentFactoryResolver) {
        this.factory = resolver.resolveComponentFactory(LoaderComponent);
    }
    show(name: string) {
        this.switchLoader('add', name);
    }
    hide(name: string) {
        this.switchLoader('remove', name);
    }
    hideAll() {
        for (let name of this.actions) {
            this.switchLoader('remove', name);
        }
    }
    isLoading() {
        return Boolean(this.actions.length);
    }
    ngOnDestroy() {
        if (this.ref) {
            this.ref.destroy();
            this.ref = null;
        }
    }
    private switchLoader(action: 'add'|'remove', name: string) {
        const index = this.actions.indexOf(name, 0);
        if (action === 'remove' && index > -1) {
            this.actions.splice(index, 1);
        } else if (action === 'add' && index === -1) {
            this.actions.push(name);
        }

        if (this.isLoading() !== this.previousState) {
            if (this.isLoading()) {
                const onStable = this.zone.onStable.subscribe(() => {
                    onStable.unsubscribe();
                    // There is cache for config. But getting item from that cache executed inside
                    // @useLoader section. This allows not to create loader if @useLoader section
                    // has been left before angular's zone became stable (probably if @useLoader
                    // section has been left in same iteration)
                    if (this.isLoading()) {
                        this.ref = this.container.createComponent(this.factory);
                        this.ref.changeDetectorRef.detectChanges();
                    }
                });
            } else {
                this.ngOnDestroy();
            }
            this.previousState = this.isLoading();
        }
    }
}
